import { parseDate } from "./dateHelpers";

const getDataByMonth = (targetMonth, targetYear, data) => {
    return data.filter((elem) => {
        return checkMonth(elem.startDate, targetMonth, targetYear);
    });
}

const checkMonth = (date, targetMonth, targetYear) => {
    targetMonth = targetMonth + "";
    targetYear = targetYear + "";
    let elemDate = new Date(date);
    let elemMonth = elemDate.getMonth() + "";
    let elemYear = elemDate.getFullYear() + "";
    if (elemMonth == targetMonth && elemYear === targetYear)
        return true;
    return false
}

export default getDataByMonth;

export function calculateAmountAfterDiscount(amount, discount) {
    let payableAmount = (amount - discount * amount / 100);
    return payableAmount.toFixed(2);
}

export function getDiscountAmount(amount, discount) {
    let discountAmount = discount * amount / 100;
    return discountAmount.toFixed(2);
}

export function getUniqueAccountsObj(arr) {
    let accountsObj = {};
    arr.forEach((a) => {
        let {companyId, companyName, companyAddress, email, phone, dispatcherId, ...billingInfo} = a;
        if (accountsObj[companyId] === undefined) {
            accountsObj[companyId] = {companyId, companyName, companyAddress, email, phone, dispatcherId};
            accountsObj[companyId].billingArr = [];
        }
        accountsObj[a.companyId].billingArr.push(billingInfo);
    });
    return accountsObj;
}

export const sortTableByMonth = (prevCom, curCom) => {
    let prevDate = "1 " + prevCom[0];
    let curDate = "1 " + curCom[0]
    return sortByMonth(prevDate, curDate);
}

export const sortByMonth = (prev, cur) => {
    let prevMonth = new Date(prev);
    let curMonth = new Date(cur);
    return curMonth.getTime() - prevMonth.getTime();
}

export const isCurrentMonth = (date) => {
    const currentDate = new Date();
    const targetDate = new Date(date);
    return targetDate.getMonth() === currentDate.getMonth() && targetDate.getFullYear() === currentDate.getFullYear();
}

export const isLastMonth = (date) => {
    const currentDate = new Date();
    const targetDate = parseDate(date);
    if (targetDate.getFullYear() === currentDate.getFullYear())
        return targetDate.getMonth() === currentDate.getMonth() - 1;
    else 
        return currentDate.getMonth() === 0 && targetDate.getMonth() === 11 && targetDate.getFullYear() === currentDate.getFullYear() - 1;
}
